import robuxModule from '../robuxModule';

function robuxContainerBase(premiumConstants) {
  'ngInject';

  return {
    restrict: 'A',
    scope: false,
    templateUrl: premiumConstants.templates.robuxContainerBase,
    link(scope, elem, attr) {
      scope.isStarcodeMobileEnabled = attr.isStarcodeMobileEnabled === 'true';
      scope.isPurchaseWarningModalEnabled = attr.isScaryModalEnabled === 'true';
    }
  };
}

robuxModule.directive('robuxContainerBase', robuxContainerBase);

export default robuxModule;
